// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2r2aa","socials":"footer-module--socials--2HA1y","social":"footer-module--social--3cljd"};